const api = {
    fetchData: async (url) => {
        const res = await fetch(url);
        if (!res.ok) throw new Error('Сервер ответил ошибкой.');
        return res.text();
    },
    jsonData: async (url) => {
        const res = await fetch(url);
        if (!res.ok) throw new Error('Сервер ответил ошибкой.');
        return res.json();
    },
    postData: async (url, data) => {
        const res = await fetch(url, {
            method: 'POST',
            headers: {'Content-type': 'application/x-www-form-urlencoded'},
            body: data,
        });
        if (!res.ok) throw new Error('Сервер ответил ошибкой.');
        return res.json();
    },
};

export default api;
